(() => {
    // for any unloaded images wait until they are loaded then resize the window
    Promise.all(Array.from(document.images).filter(img =>  !img.complete && img.loading !== "lazy" ).map(img => new Promise(resolve => { img.onload = img.onerror = resolve; }))).then(() => {
        window.dispatchEvent(new Event("resize"));
    });
})();